import { NgModule, Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GlobalModule } from '@global/global.module';
import { MediaService } from '@app/media/media.service';

@Component({
	selector: 'media-icon',
	standalone: false,
	template: /*html*/`
	@switch (tym_code) {

		@case ('image') {
			@if (isFile && displayableImage) {
				<img [src]="file!.objectURL" loading="lazy"/>
			}
			<span>
				@if (!isFile || !displayableImage) {
					<i class="text-xl pi pi-icon pi-image"></i>
				}
			</span>
		}
		@case ('video') { <i class="text-xl pi pi-video"></i>	}
		@case ('lien') { <i class="text-xl pi pi-external-link"></i> }
		@case ('excel') { <i class="text-xl pi pi-file-excel"></i> }
		@case ('doc') { <i class="text-xl pi pi-file-word"></i> }
		@case ('pdf') { <i class="text-xl pi pi-file-pdf"></i> }
		@case ('texte') { <i class="text-xl pi pi-align-left"></i> }
		@default { <i class="text-xl pi pi-file"></i> }
	}
	`,
	providers: [],
})
export class MediaIconComponent implements OnInit {

	@Input() tym_code: any = null;
	@Input() file?: any;

	isFile: boolean = false;
	displayableImage: boolean = false;

	constructor(private mediaService: MediaService) {

	}

	ngOnInit(): void {
		if (this.file) {
			this.isFile = this.file instanceof File;
			this.displayableImage = this.mediaService.isDisplayableImage(this.file);
			this.tym_code = this.mediaService.getFileType(this.file);
		}
	}


}


@NgModule({
	imports: [
		CommonModule,
		GlobalModule
	],
	exports: [
		MediaIconComponent,
	],
	declarations: [MediaIconComponent]
})
export class MediaIconModule { }
